import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { ZONES } from "@/data/site";

export const Zones = () => {
  return (
    <section id="zones" className="bg-mh-bg2 border-y border-mh-line">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-32 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <span className="text-xs tracking-[0.25em] uppercase text-mh-orange font-bold">Zones d'intervention</span>
          <h2 className="mt-5 font-display font-bold text-4xl sm:text-5xl tracking-tight text-white leading-[0.95]">
            Présents dans tout le Var & les Alpes-Maritimes
          </h2>
          <p className="mt-6 text-mh-slate leading-relaxed max-w-md">
            Basés à Fréjus, nous intervenons rapidement sur l'ensemble du littoral azuréen
            et à l'intérieur des terres, dans toute la région PACA.
          </p>
        </div>

        <div className="flex flex-wrap gap-3">
          {ZONES.map((z, i) => (
            <motion.span
              key={z}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="inline-flex items-center gap-2 border border-mh-line bg-mh-bg px-5 py-3 text-sm text-white hover:border-mh-orange hover:text-mh-orange transition-colors"
              data-testid={`zone-${i}`}
            >
              <MapPin size={14} className="text-mh-orange" /> {z}
            </motion.span>
          ))}
        </div>
      </div>
    </section>
  );
};
